import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from '@/store';

// 基础API配置
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: (headers, { getState }) => {
      // 可以在这里添加认证token等
      const state = getState() as RootState;
      const token = state.user.currentUser?.id; // 示例
      
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      
      headers.set('content-type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['User', 'App'], // 用于缓存失效
  endpoints: () => ({}), // 具体的endpoints将在其他文件中定义
});

// 导出hooks生成器
export const { 
  // 这些hooks将在具体的API文件中生成
} = baseApi;